import React, { useEffect } from 'react';

import { HashRouter, Route, Switch } from 'react-router-dom';

import { CenterWrapper, FocusedLayout } from '@brokerbay/design-components';
import { featureFlagClient, featureEnabled } from 'utils';

import { AppErrorBoundary } from '../components';
import {
  OnboardingClaimView,
  OnboardingCompleteProfileView,
  OnboardingOrgClaimView,
  OnboardingOrgSelectView,
} from './pages';
import { ClaimPrefix } from './constants';
import {
  LayoutContextProvider,
  ListingLabelContextProvider,
} from '../../contexts';

const OnboardingRouter = () => {
  useEffect(() => {
    // Initializing launchdarkly
    (async () => {
      await featureFlagClient.initialize();
    })();
  }, []);

  return (
    <HashRouter>
      <LayoutContextProvider entryRoute="onboarding">
        <ListingLabelContextProvider>
          <AppErrorBoundary>
            <FocusedLayout clean>
              <CenterWrapper>
                <Switch>
                  <Route exact path="/" component={OnboardingClaimView} />

                  <Route
                    path={ClaimPrefix.USER_PROFILE}
                    component={OnboardingCompleteProfileView}
                  />

                  <Route
                    path={ClaimPrefix.ORG_SELECT}
                    component={OnboardingOrgSelectView}
                  />

                  <Route
                    path={ClaimPrefix.ORG_PROFILE}
                    component={OnboardingOrgClaimView}
                  />
                </Switch>
              </CenterWrapper>
            </FocusedLayout>
          </AppErrorBoundary>
        </ListingLabelContextProvider>
      </LayoutContextProvider>
    </HashRouter>
  );
};

export default OnboardingRouter;
